export default "__VITE_ASSET__CD0Q5mJK__"